import { render } from "./WNrestartRecordList.vue?vue&type=template&id=2979f4c3&scoped=true"
import script from "./WNrestartRecordList.vue?vue&type=script&lang=js"
export * from "./WNrestartRecordList.vue?vue&type=script&lang=js"

import "./WNrestartRecordList.vue?vue&type=style&index=0&id=2979f4c3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2979f4c3"

export default script